import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, GET_SETTINGS, GET_ALL_BOOTH, EDIT_SETTINGS } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing GET request and response contract. */
export function getSettings(token) {
  return axiosInstance(`${baseUrl}/${GET_SETTINGS}`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function getAllBooth(token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_BOOTH}?page=1&Limit=1000`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editSettings(data, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_SETTINGS}`, data, configReq(token));
}
